import { render, staticRenderFns } from "./FeedItemEdit.vue?vue&type=template&id=f891d7b8"
import script from "./FeedItemEdit.vue?vue&type=script&lang=js"
export * from "./FeedItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports